<template>
  <div class="w-100">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-else-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <template v-else>
      <div>
        <button
          v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
          v-b-modal.addUserModal
          v-b-tooltip.hover
          class="btn btn-success float-right"
          placement="bottom"
          title="Neuer Benutzer hinzufügen"
        >
          <i class="fas fa-plus" />
        </button>
        <b-modal
          id="addUserModal"
          ref="addUserModal"
          hide-footer
          no-fade
          scrollable
          title="Neuer Benutzer erstellen"
        >
          <div class="d-block mb-4">
            <b-container>
              <u-error-handling
                v-if="addUserError"
                :error-object="addUserError"
              />
              <b-row>
                <v-autocomplete
                  v-model="activedirectoryUser"
                  :filter="filterActivedirectoryUsers"
                  :items="activedirectoryUsers"
                  class="mb-4"
                  clearable
                  placeholder="aus Active Directory auswählen..."
                  return-object
                  @change="addUserFromActivedirectory"
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    <div>
                      {{ getActivedirectoryUserDisplayString(data.item) }}
                    </div>
                  </template>

                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <div>
                      {{ getActivedirectoryUserDisplayString(data.item) }}
                    </div>
                  </template>
                </v-autocomplete>
              </b-row>
              <b-row class="">
                <label class="pl-0 mt-3 col-4 defaultLabel">
                  Benutzername
                </label>
                <div class="col-8 pl-1">
                  <v-text-field
                    id="usernameInput"
                    v-model="newUserObject.email"
                    placeholder="e-Mail Adresse"
                  />
                </div>
              </b-row>
              <b-row class="">
                <label class="pl-0 mt-4 col-4 defaultLabel"> Vorname </label>
                <div class="col-8 pl-1">
                  <v-text-field
                    id="usernameInput"
                    v-model="newUserObject.firstName"
                    placeholder="Vorname"
                  />
                </div>
              </b-row>
              <b-row class="">
                <label class="pl-0 mt-4 col-4 defaultLabel"> Nachname </label>
                <div class="col-8 pl-1">
                  <v-text-field
                    id="usernameInput"
                    v-model="newUserObject.lastName"
                    placeholder="Nachname"
                  />
                </div>
              </b-row>
            </b-container>
            <b-button
              variant="success"
              @click="createNewUser()"
            >
              Ok
            </b-button>
            <b-button
              class="ml-2"
              variant="danger"
              @click="hideModal('addUserModal')"
            >
              Abbrechen
            </b-button>
          </div>
        </b-modal>
      </div>
      <div class="col-4">
        <v-text-field
          id="usernameInput"
          v-model="searchTerm"
          label="Nach Benutzername suchen..."
        />
      </div>
      <table class="w-100 userOverview ml-2 mt-4">
        <thead>
          <tr>
            <th>Benutzername</th>
            <th>Vorname</th>
            <th>Nachname</th>
            <th>Gesperrt</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in filteredUsers"
            :key="user.id"
          >
            <td>{{ user.email }}</td>
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.locked ? "ja" : "nein" }}</td>
            <td>
              <button
                v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                class="btn btn-primary smallActionButton"
                title="Bearbeiten"
                @click="openUser(user.id)"
              >
                <i class="fas fa-edit" />
              </button>

              <button
                v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                class="btn btn-danger smallActionButton ml-2"
                title="Löschen"
                @click="deleteUser(user.id)"
              >
                <i class="fas fa-trash" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import {
  GetAllUsers,
  CreateNewUser,
  DeleteUser,
  GetActivedirectoryUsers,
} from "@/services/user.service.js";

export default {
  data() {
    return {
      allUsers: [],
      isLoading: false,
      errorObject: null,
      addUserError: null,
      searchTerm: "",
      filteredUsers: [],
      newUserObject: {
        id: "34535",
        firstName: "",
        lastName: "",
        email: "",
        locked: false,
        roles: [],
      },
      activedirectoryUsers: [],
      activedirectoryUser: "",
    };
  },
  watch: {
    searchTerm() {
      this.filterUsers();
    },
  },
  created() {
    this.LoadAllUsers();
  },
  methods: {
    filterActivedirectoryUsers(option, search) {
      if (option.lastName && option.firstName && option.email) {
        return (
          option.firstName.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
          option.lastName.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
          option.email.toLowerCase().indexOf(search.toLowerCase()) > -1
        );
      } else if (option.lastName && option.firstName) {
        return (
          option.firstName.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
          option.lastName.toLowerCase().indexOf(search.toLowerCase()) > -1
        );
      } else if (option.lastName) {
        return option.lastName.toLowerCase().indexOf(search.toLowerCase()) > -1;
      } else if (option.email) {
        return option.email.toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
    },
    addUserFromActivedirectory() {
      if (this.activedirectoryUser) {
        this.newUserObject.email = this.activedirectoryUser.email;
        this.newUserObject.firstName = this.activedirectoryUser.firstName;
        this.newUserObject.lastName = this.activedirectoryUser.lastName;
        this.newUserObject.adObjectGuid = this.activedirectoryUser.adObjectGuid;
      }
    },
    getActivedirectoryUserDisplayString(item) {
      if (item.userName) {
        return item.userName;
      }
      if (item.lastName && item.firstName) {
        return item.lastName + " " + item.firstName;
      }
      if (item.lastName) {
        return item.lastName;
      }
      return "";
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    deleteUser(userId) {
      DeleteUser(
        userId,
        () => {
          this.LoadAllUsers();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createNewUser() {
      this.addUserError = null;

      CreateNewUser(
        this.newUserObject,
        (success) => {
          this.hideModal("addUserModal");
          this.newUserObject = {
            id: "0",
            firstName: "",
            lastName: "",
            email: "",
            locked: false,
            roles: [],
          };

          this.$router.push({
            path: `/users/${success}`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.addUserError = error;
        },
      );
    },
    filterUsers() {
      if (this.searchTerm == "") {
        this.filteredUsers = this.allUsers;
      } else {
        this.filteredUsers = JSON.parse(JSON.stringify(this.allUsers)).filter(
          (user) => {
            return (
              (user.email &&
                user.email
                  .toLowerCase()
                  .indexOf(this.searchTerm.toLowerCase()) != -1) ||
              (user.firstName &&
                user.firstName
                  .toLowerCase()
                  .indexOf(this.searchTerm.toLowerCase()) != -1) ||
              (user.lastName &&
                user.lastName
                  .toLowerCase()
                  .indexOf(this.searchTerm.toLowerCase()) != -1)
            );
          },
        );
      }
    },
    openUser(userId) {
      this.$router.push({
        path: "users/" + userId,
      });
    },
    LoadActivedirectoryUsers() {
      this.errorObject = null;

      GetActivedirectoryUsers(
        (response) => {
          this.activedirectoryUsers = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoadAllUsers() {
      this.isLoading = true;
      this.errorObject = null;

      GetAllUsers(
        (response) => {
          this.allUsers = response;
          this.filterUsers();
          this.LoadActivedirectoryUsers();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.userOverview {
  font-size: small;
  table-layout: fixed;
}

.userOverview thead th:nth-child(1) {
  width: 35%;
}

.userOverview thead th:nth-child(2) {
  width: 20%;
}

.userOverview thead th:nth-child(3) {
  width: 20%;
}

.userOverview thead th:nth-child(5) {
  width: 10%;
}

.userOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.userOverview td,
.userOverview th {
  padding: 8px 4px;
}
</style>
